import { defineStore } from 'pinia';
import actions from './actions.js';

function initState() {
    return {
        agents: [],
        formListState: []
    };
}

export default storeName =>
    defineStore(storeName, {
        state: initState,
        actions
    });
